import * as Yup from 'yup';
import { isValidDocument, isValidIban, isValidPhone } from './idValidators';

export const signupSchema = Yup.object({
  email: Yup.string()
    .email("Email inválido")
    .required("Email requerido"),

  password: Yup.string()
    .min(8, "Mínimo 8 caracteres")
    .matches(/^(?=.*[A-Za-z])(?=.*\d)/, "Debe contener letras y números")
    .required("Contraseña requerida"),

  re_password: Yup.string()
    .oneOf([Yup.ref('password')], "Las contraseñas no coinciden")
    .required("Confirmar contraseña requerido"),

  first_name: Yup.string().required("Nombre requerido"),
  last_name: Yup.string().required("Apellidos requeridos"),
  document_id: Yup.string()
    .required("Documento requerido")
    .test(
      'valid-document',
      'Documento inválido (DNI/NIE/CIF/Pasaporte)',
      (value) => isValidDocument(value)
    ),
  phone: Yup.string()
    .required("Teléfono requerido")
    .test(
      'valid-phone',
      'Teléfono inválido (9-15 dígitos)',
      (value) => isValidPhone(value)
    ),

  responsible: Yup.string().when(['is_internal_agent', 'is_call_agent'], {
    is: (isInternal, isCallAgent) => !(isInternal || isCallAgent),
    then: (schema) =>
      schema
        .required('Gestor de cuenta requerido')
        .matches(/^\d+$/, 'Debe ser numérico'),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),

  prescriptor: Yup.string()
    .test('is-numeric', 'Debe ser numérico', value =>
      !value || /^\d+$/.test(value)
    ),
  bank_account: Yup.string()
    .transform((value) => (typeof value === 'string' ? value.trim() : value))
    .required("IBAN requerido")
    .test(
      'valid-iban',
      'IBAN inválido',
      (value) => !value || isValidIban(value)
    ),
  delegacion: Yup.string().required("La delegación es obligatoria"),
  is_internal_agent: Yup.boolean().optional(),
  is_call_agent: Yup.boolean().optional(),
  // Campos opcionales
  erp_user_id: Yup.string()
    .transform(v => (v === '' ? null : v))
    .when('is_internal_agent', {
      is: true,
      then: (schema) =>
        schema
          .required('ERP user id requerido')
          .matches(/^\d+$/, 'Debe ser numérico'),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

  price_list_preffix: Yup.string(),
  parent: Yup.string(),

  coeficient_d: Yup.number()
    .typeError("El coeficiente D debe ser un número entero")
    .integer("El coeficiente D debe ser un número entero")
    .required("Coeficiente D requerido"),
});
